import { SelectItem } from "../components/MySelect";

export function convertToSelectedItem<T>(item: T, valueField: keyof T, labelField: keyof T) {
    return { value: item[valueField], label: item[labelField] as any } as SelectItem;
}
